import { useMutation } from "@apollo/client";
import { LoadingButton } from "@mui/lab";
import { t } from "i18next";
import React, { useState } from "react";
import { client } from "../..";
import { disablePersonFromCompany, enablePersonFromCompany } from "../../api/api";
import { showErrorMessage } from "../../helper/helper";
import { Employee } from "../../models/organisation/OrganisationModelV2";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";

type Props = {
    employee: Employee
    orgId: number
    dbRefetch?: () => void
}

// Props: personId (number), isEnabled (boolean), onStatusChange (optional callback)
const EnableEmployeeToggle: React.FC<Props> = ({ employee, orgId, dbRefetch }: Props) => {
    const [openAlert, setOpenAlert] = useState(false)

    const [disableQuery, { loading: loadingDisable, error: errorDisale }] = useMutation(
        disablePersonFromCompany,
        {
            client: client,
            onCompleted: () => {
                dbRefetch?.();
            },
            onError: (e) => {
                showErrorMessage(e)
            }
        }
    );

    const [enableQuery, { loading: loadingEnable, error: errorEnable }] = useMutation(
        enablePersonFromCompany,
        {
            client: client,
            onCompleted: () => {
                dbRefetch?.();
            },
            onError: (e) => {
                showErrorMessage(e)
            }
        }
    );

    const toggleState = () => {
        setOpenAlert(false)
        const toggle = employee.isEnable()
        const variables = {
            input: {
                person_id: employee.personId(),
                organisation_id: orgId
            }
        }
        if (toggle === true) {
            disableQuery({
                variables: variables
            });
        } else {
            enableQuery({
                variables: variables
            })
        }
    };

    return (
        <>
            <LoadingButton
                onClick={() => setOpenAlert(true)}
                loading={loadingDisable || loadingEnable}
                color={employee.isEnable() ? 'primary' : 'error'}>
                {employee.isEnable() ? t('enabled') : t('disabled')}
            </LoadingButton>

            <Dialog
                open={openAlert}
                onClose={() => setOpenAlert(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {
                            employee.isEnable() ?
                                t('disable_person_company',
                                    {
                                        name: employee?.person?.getFullName() ?? employee?.person?.user?.email
                                    })
                                :
                                t('enable_person_company',
                                    {
                                        name: employee?.person?.getFullName() ?? employee?.person?.user?.email
                                    })
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={toggleState}>{t('yes')}</Button>
                    <Button onClick={() => setOpenAlert(false)} autoFocus>
                        {t('no')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default EnableEmployeeToggle;
